"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectAllOption = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _i18n = require("../../../../i18n/i18n");
var _visuallyhidden = require("../../../visuallyhidden");
var _MultiSelectOption = require("./MultiSelectOption");
const SelectAllOption = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    checkedState,
    totalSelectedItems,
    totalOptions,
    ...rest
  } = _ref;
  const {
    i18n
  } = (0, _i18n.useI18n)();
  const allSelected = totalSelectedItems === totalOptions;
  const ariaLabel = (0, _react.useMemo)(() => {
    switch (allSelected) {
      case true:
        return i18n._( /*i18n*/{
          comment: "This aria label is read to the user conveying the number of items selected. Then full stop. Then it conveys that clicking on the option will deselect all the items",
          id: `{totalSelectedItems} selected. Deselect all`,
          values: {
            totalSelectedItems
          }
        });
      case false:
        return i18n._( /*i18n*/{
          comment: "This aria label is read to the user conveying the number of items selected. Then full stop. Then it conveys that clicking on the option will select all the items",
          id: `{totalSelectedItems} selected. Select all {totalOptions} items`,
          values: {
            totalSelectedItems,
            totalOptions
          }
        });
    }
  }, [allSelected, totalOptions, totalSelectedItems, i18n]);
  return /*#__PURE__*/_react.default.createElement(_MultiSelectOption.MultiSelectOption, (0, _extends2.default)({
    checkedState: checkedState,
    ref: ref,
    onClick: e => {
      rest.onClick?.(e);
    },
    "aria-label": ariaLabel
  }, rest), totalSelectedItems === 0 ? i18n._( /*i18n*/"Select All") : i18n._( /*i18n*/{
    comment: "This is to show the number of selected items",
    id: `{totalSelectedItems} selected`,
    values: {
      totalSelectedItems
    }
  }), /*#__PURE__*/_react.default.createElement(_visuallyhidden.VisuallyHidden, null, i18n._( /*i18n*/"Press Enter to select or deselect an option.")));
});
exports.SelectAllOption = SelectAllOption;
SelectAllOption.displayName = "SelectAllOption";
//# sourceMappingURL=SelectAllOption.js.map